// Locale switching functionality

document.addEventListener('turbo:load', () => {
  $('.locale-flag').on('click', function() {
    const locale = $(this).data('locale')
    
    fetch('/locale', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      body: JSON.stringify({ locale: locale })
    }).then(() => {
      // Reload with current URL (preserves query params like filters)
      window.location.reload()
    }).catch(error => {
      console.error('Failed to change locale:', error)
    })
  })
})
